import axios from 'axios';
import config from 'src/config';
import { getTokensFromStorage } from 'src/tools/getTokensFromStorage';

const apiUrl = `${config.apiUrl.approvals}`;
const tokens = getTokensFromStorage();
const headers = {
  ...config.apiHeaders,
  'user-token': tokens['user-token'],
  'cart-token': tokens['cart-token'],
};

export const onAcceptApprovals = async () => {
  try {
    const { data } = await axios.post(`${config.baseUrl}${apiUrl}`, {
      approvals: {
        policy: true
      }
    }, { headers });

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
